import SF from '../ConnectedSelectField'
import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: SF,
  name: 'DDISelectField'
})
